import { render, staticRenderFns } from "./ybdqk.vue?vue&type=template&id=4d4cb676"
import script from "./ybdqk.vue?vue&type=script&lang=js"
export * from "./ybdqk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports